import { useState } from "react"
import { mutate } from "swr"
import { PickingShortageApi } from "../../../apis"
import type { IReportShortageInput } from "../../../apis"

const invalidate = () =>
  mutate((key) => Array.isArray(key) && (key[0] === "pull-sheet-shortages" || key[0] === "pull-sheet-decision"), undefined, { revalidate: true })

/** Backend error with the parts the dialog branches on (HttpHandler is not an Error). */
export class ShortageRequestError extends Error {
  statusCode?: number
  code?: string
  constructor(source: unknown) {
    const s = source as { message?: string; statusCode?: number; code?: string } | null
    super(s?.message ?? String(source))
    this.statusCode = s?.statusCode
    this.code = s?.code
  }
  get alreadyReported() {
    return this.statusCode === 409 || this.code === "SHORTAGE_ALREADY_REPORTED" || this.message === "error.shortage.already_reported"
  }
}

export function useShortageMutations() {
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState<ShortageRequestError | null>(null)

  async function wrap<T>(fn: () => Promise<T>): Promise<T> {
    setSubmitting(true)
    setError(null)
    try {
      const r = await fn()
      await invalidate()
      return r
    } catch (e) {
      const err = new ShortageRequestError(e)
      setError(err)
      throw err
    } finally {
      setSubmitting(false)
    }
  }

  return {
    submitting,
    error,
    clearError: () => setError(null),
    reportShortage: (psId: string, lineId: string, body: IReportShortageInput) => wrap(() => PickingShortageApi.reportShortage(psId, lineId, body)),
  }
}
